import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=4b259a60&"
import script from "./PdfViewer.vue?vue&type=script&lang=js&"
export * from "./PdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=4b259a60&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b259a60')) {
      api.createRecord('4b259a60', component.options)
    } else {
      api.reload('4b259a60', component.options)
    }
    module.hot.accept("./PdfViewer.vue?vue&type=template&id=4b259a60&", function () {
      api.rerender('4b259a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/FileViewers/PdfViewer.vue"
export default component.exports